import { useEffect } from 'react'

/**
 * Fade out the static boot splash (index.html #um-loading) once the first
 * REAL screen is ready to paint. Every entry surface calls this; gated
 * surfaces pass `ready` so the splash covers auth + profile resolution
 * instead of flashing a blank shell (clubmanager's use-app-ready port).
 */
export function useAppReady(ready: boolean = true): void {
  useEffect(() => {
    if (!ready) return
    if (typeof document === 'undefined') return
    document.body.classList.add('app-ready')
  }, [ready])
}
